import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcFormFooter]'
})
export class FormFooterDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
